export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    jQuery('.navbar-toggler').click(function(){
      $(this).toggleClass('menu-opened');
    });
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js